jQuery( function($) {

  window.cookie = {}

  window.cookie.set = function( cname, cvalue, exdays ) {
    let date = new Date()
    let expires = 0

    date.setTime( date.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) )
    expires = 'expires=' + date.toUTCString()

    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
  }

  window.cookie.get = function( cname ) {
    let name = cname + '='
    let decodedCookie = decodeURIComponent( document.cookie )
    let ca = decodedCookie.split(';')

    for( var i = 0; i <ca.length; i++ ) {
      let c = ca[i]

      while ( c.charAt(0) == ' ' )
        c = c.substring(1)

      if( c.indexOf( name ) == 0 )
        return c.substring( name.length, c.length )
    }
    return ''
  }
})



// WEBPACK FOOTER //
// ./src/js/cookie.js